import React from "react";

export default function About() {
  return (
    <section className="container">
      <h3 className="my-5 text-center">About Us</h3>

      <article className="text-center my-4">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium
        autem ipsam repudiandae beatae minus vel consectetur ex quisquam
        eligendi, praesentium sit iusto incidunt, facere obcaecati rem eos
        molestias unde, quam pariatur dicta deserunt impedit et. Similique, vel.
        Minus illum ad illo consequuntur libero tempora, nostrum est recusandae
        dolor, impedit maxime.
      </article>

      <article className="text-center">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium
        autem ipsam repudiandae beatae minus vel consectetur ex quisquam
        eligendi, praesentium sit iusto incidunt, facere obcaecati rem eos
        molestias unde, quam pariatur dicta deserunt impedit et. Similique, vel.
        Minus illum ad illo consequuntur libero tempora, nostrum est recusandae
        dolor, impedit maxime.
      </article>
    </section>
  );
}
